
import { Options, Vue } from "vue-class-component";

@Options({})
export default class Dataportal extends Vue {}
